<template>
  <div class="payment-methods__buttons">
    <button
      v-if="paymentGateway.methods.massPayAch && !hiddenElements.tendr"
      class="button button--large button--black"
      type="button"
      @click="mockTendr"
    >
      Tendr
    </button>

    <button
      v-if="canUseApplePay"
      class="special-button special-button--apple-pay"
      type="button"
      @click="selectMethod('ApplePay')"
    >
      Apple Pay
    </button>

    <button
      v-if="canUseGooglePay"
      class="special-button special-button--google-pay"
      type="button"
      @click="selectMethod('GooglePay')"
    >
      Google Pay
    </button>

    <div id="payment-method-gift-card" />

    <div id="payment-method-charge-room" />
  </div>
</template>

<script>
  import applePay from '@/services/apple-pay';
  import events from '@/services/events';
  import googlePay from '@/services/google-pay';


  export default {
    name: 'PaymentMethodsStandard',

    props: {
      forceSaveCards: {
        type: Boolean,
        default: false
      },

      giftCardReloadPaymentMethod: {
        type: [Object, Boolean],
        default: null
      },

      hiddenElements: {
        type: Object,
        default: () => ({})
      },

      paymentGateway: {
        type: Object,
        required: true
      },

      selectedPaymentMethod: {
        type: String,
        default: ''
      },

      total: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        canUseApplePay: false,
        canUseGooglePay: false
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.initializeLibrary();
      },

      initializeLibrary() {
        this.detectApplePay();

        this.detectGooglePay();

        this.$emit('set-loading-status', false);
      },

      detectApplePay() {
        if (this.validatePaymentMethodSupport('apple-pay')) {
          const isApplePaySupported = applePay.isSupported();

          this.canUseApplePay = isApplePaySupported;

          if (isApplePaySupported) this.$emit('set-enabled-payment-method', 'apple-pay');

          if (!isApplePaySupported) {
            this.$emit('unsupported-method', 'ApplePay');
          }
        }
      },

      async detectGooglePay() {
        if (this.validatePaymentMethodSupport('google-pay')) {
          const { result: isGooglePaySupported } = await googlePay.isSupported({
            paymentGateway: this.paymentGateway
          });

          this.canUseGooglePay = isGooglePaySupported;

          if (isGooglePaySupported) this.$emit('set-enabled-payment-method', 'google-pay');

          if (!isGooglePaySupported) {
            this.$emit('unsupported-method', 'GooglePay');
          }
        }
      },

      validatePaymentMethodSupport(methodType) {
        const enabledMethods = {
          'apple-pay': this.paymentGateway.methods.applePay && (!this.forceSaveCards || this.paymentGateway.methods.giftCard?.paymentMethods.applePayRecurringEnabled),
          'google-pay': this.paymentGateway.methods.googlePay && (!this.forceSaveCards || this.paymentGateway.methods.giftCard?.paymentMethods.googlePayRecurringEnabled)
        };

        return enabledMethods[methodType];
      },

      /** NOTE: This is a temporary method for demo purposes and is not unit tested */
      mockTendr() {
        events.emit('notification', {
          type: 'success',
          clickToDismiss: true,
          message: 'Coming soon!'
        });
      },

      selectMethod(method) {
        this.$emit('before-submit', {
          method,
          onValidated: this.submitMethod
        });
      },

      async submitApplePay() {
        try {
          const event = await applePay.requestPayment({
            paymentGateway: this.paymentGateway,
            total: this.total
          });

          this.$emit('submitted', {
            contactInfo: {
              email: event.payment.shippingContact.emailAddress,
              fullName: `${event.payment.billingContact.givenName} ${event.payment.billingContact.familyName}`,
              phoneNumber: event.payment.shippingContact.phoneNumber
            },
            paymentMethod: {
              type: 'apple-pay',
              event
            }
          });
        }

        catch (error) {
          this.$emit('error', error);
        }
      },

      async submitGooglePay() {
        try {
          const event = await googlePay.requestPayment({
            paymentGateway: this.paymentGateway,
            total: this.total
          });

          this.$emit('submitted', {
            contactInfo: {
              email: event.email,
              fullName: event.paymentMethodData.info.billingAddress.name,
              phoneNumber: event.paymentMethodData.info.billingAddress.phoneNumber
            },
            paymentMethod: {
              type: 'google-pay',
              event
            }
          });
        }

        catch (error) {
          this.$emit('error', error);
        }
      },

      submitMethod(method) {
        if (method === 'ApplePay') {
          this.submitApplePay();
        }

        else if (method === 'GooglePay') {
          this.submitGooglePay();
        }
      }
    }
  };
</script>
